import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Success from "@/pages/Success";
import AdminGallery from "@/pages/AdminGallery";
import AdminReviews from "@/pages/AdminReviews";
import AdminSettings from "@/pages/AdminSettings";
import AdminBookings from "@/pages/AdminBookings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<AdminGallery />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
          <Route path="/admin/reviews" element={<AdminReviews />} />
          <Route path="/admin/site" element={<AdminSettings />} />
          <Route path="/admin/bookings" element={<AdminBookings />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#111111",
            color: "#ffffff",
            border: "1px solid #262626",
          },
        }}
      />
    </div>
  );
}

export default App;
